"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoContent = exports.VideoContainer = exports.Content = exports.Container = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _breakpoints = require("@titelmedia/bricks-theme/lib/variables/breakpoints");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const setApplication = applyToDevice => {
  switch (applyToDevice) {
    case 'desktop':
      return (0, _styledComponents.css)`
        @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
          display: none;
        }
      `;
    case 'mobile':
      return (0, _styledComponents.css)`
        @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
          display: none;
        }
      `;
    case 'both':
      return;
    default:
      return;
  }
};
const Container = _styledComponents.default.div`
  padding: ${props => props.usePadding ? '0 20px' : '0! important'};
  margin: 0 auto;
  max-width: 100%;
  width: 100%;
  @media (min-width: ${_breakpoints.BREAKPOINTS.xxl}px) {
    padding: 0 160px;
  }
`;
exports.Container = Container;
const Content = _styledComponents.default.div`
  position: relative;
  width: 100%;
  ${props => props.controlColors && `
  .plyr--full-ui input[type=range] {
    color: ${props.controlColors};
  }
  .plyr--video .plyr__control.plyr__tab-focus,
  .plyr--video .plyr__control:hover,
  .plyr--video .plyr__control[aria-expanded=true] {
    background: ${props.controlColors};
  }
  `};
  ${props => props.setPosterImage && `
  .plyr__poster {
    background-size: cover;
  }
  `};
  ${props => props.hideControls && `
  .plyr__controls {
    display: none;
    }
  `};
  ${props => props.aspectRatio && `
  .plyr__video-embed {
    aspect-ratio: ${props.aspectRatio}!important;
  }
  `};
`;
exports.Content = Content;
const VideoContainer = _styledComponents.default.div`
  display: flex;
  ${props => props.triggerInViewport && `
    min-height: 100vh;
    justify-content: center;
    align-items: center;
`};
  ${props => setApplication(props.applyToDevice)};
`;
exports.VideoContainer = VideoContainer;
const VideoContent = _styledComponents.default.div`
  position: relative;
`;
exports.VideoContent = VideoContent;
//# sourceMappingURL=styles.js.map